<script>
import AdaptersChart from "../adapters/Chart.vue";
import {nextTick} from "vue";

    export default {
        props: {
            data: {
                type: Object,
                required: true
            },
            legend: {
                type: String,
                required: true
            },
            pdf: {
                type: Boolean,
                required: false,
                default: false
            },
            revertColor: {
                type: Boolean,
                required: false,
                default: false
            },
            customWaterMark: {
                type: String,
                required: false,
                default: ''
            },
            db: {
                type: String,
                required: false,
                default: ''
            },
        },
        data () {
            return {
                legends: this.$tm(this.legend),
                colors : [
                    '#4dc9f6',
                    '#f67019',
                    '#f53794',
                    '#537bc4',
                    '#acc236',
                    '#166a8f',
                    '#00a950',
                    '#58595b',
                    '#8549ba'
                ],
                base64Chart: null,
                chartData: null,
                chartOptions: null,
                isPdfLoaded: false,
            }
        },
        mounted() {
            if (this.revertColor) {
                this.colors = this.colors.reverse();
            }

            this.setChartOptions();
            this.setChartData();
        },
        computed: {
            getChartData() {
                return this.chartData;
            },
            getChartOptions() {
                return this.chartOptions;
            },
            legendItems() {
                if (this.shouldHideAiCnt) {
                    return this.legends.slice(0, -1);
                }
                return this.legends;
            },
            shouldHideAiCnt() {
                if (!this.db) {
                    return false;
                }
                return this.db.toLowerCase() !== 'msk' && this.db.toLowerCase() !== 'msk4';
            },
            getBrandLogo() {
                if (this.customWaterMark) {
                    return this.customWaterMark;
                }

                if (!this.pdf) {
                    return null;
                }

                let url = new URL(window.location.href);
                return url.origin + '/i/blackSign.svg';
            },
        },
        methods: {
            getLegendKeys() {
                const baseKeys = ['it1', 'it3', 'it5', 'it10', 'it50', 'pagesInIndex', 'adsCount', 'adKeysCount', 'visAvg', 'aiCnt'];
                if (this.shouldHideAiCnt) {
                    return baseKeys.slice(0, -1);
                }
                return baseKeys;
            },
            setChartData() {
                let self = this;
                let labels = Object.keys(this.data).map((key, index) => {
                    return key;
                });
                let dataSets = [];

                // Маппинг индексов легенды на ключи данных
                const legendKeys = this.getLegendKeys();

                this.legendItems.forEach((legend, index) => {
                    const dataKey = legendKeys[index];
                    dataSets.push({
                        label: legend,
                        fill: false,
                        backgroundColor: this.colors[index % this.colors.length],
                        borderColor: this.colors[index % this.colors.length],
                        data: Object.keys(this.data).map((key) => {
                            // Если данные - ассоциативный массив, используем ключ, иначе числовой индекс
                            if (self.data[key] && typeof self.data[key] === 'object' && !Array.isArray(self.data[key])) {
                                return dataKey ? (self.data[key][dataKey] ?? 0) : 0;
                            }
                            return self.data[key][index] ?? 0;
                        }),
                        tension: 0.3, // сглаживание
                    });
                });

                if (!this.pdf) {
                    dataSets.push({
                        label: this.$t('lang.main.hide_all'),
                        fill: false,
                        backgroundColor: this.colors[dataSets.length % this.colors.length],
                        borderColor: this.colors[dataSets.length % this.colors.length],
                        data: [],
                    });
                }

                this.chartData = {
                    labels: labels,
                    datasets: dataSets,
                };
            },
            capturePdfChart() {
                if (!this.pdf || this.isPdfLoaded) {
                    return;
                }
                nextTick(() => {
                    this.base64Chart = this.$refs.chart.toBase64Image();
                    this.isPdfLoaded = true;
                });
            },
            setChartOptions() {
                let self = this;
                this.chartOptions = {
                    plugins: {
                        legend: {
                            display: true,
                            onClick: (e, legendItem) => {
                                let index = legendItem.datasetIndex;
                                let ci = self.$refs.chart.$refs.chart.chart;
                                let meta = ci.getDatasetMeta(index);
                                let show = 0;
                                const legendLength = ci.config.data.datasets.length - 1;

                                for (let i = 0; i <= legendLength; i++) {
                                    let m = ci.getDatasetMeta(i);
                                    if (!m.hidden) {
                                        show++;
                                    }
                                }

                                if (index === legendLength) {
                                    for (let i = 0; i < legendLength; i++) {
                                        let m = ci.getDatasetMeta(i);
                                        m.hidden = show === 1 ? null : true;
                                    }
                                } else {
                                    meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                                }

                                ci.update('none');
                            }
                        },
                        tooltip: {
                            callbacks: {
                                label: (tooltipItem) => {
                                    let label = tooltipItem.dataset.label || '';
                                    if (label) {
                                        label += ': ';
                                    }

                                    return label + tooltipItem.formattedValue;
                                },
                            }
                        },
                    },
                    scales: {
                        y: {
                            ticks: {
                                callback: (value) => {
                                    return value.formatMoney(0, ' ', ' ')
                                }
                            },
                        },
                        x: {
                            scaleLabel: {
                                labelString: this.$t('lang.main.date')
                            },
                            grid: {
                                display: false // убрать вертикальные линии
                            }
                        }
                    },
                    animation: {
                        duration: 0,
                    }
                };
            },
        },
        components: {
            AdaptersChart,
        }
    }
</script>

<template>
    <div>
        <AdaptersChart
            v-show="!isPdfLoaded"
            :pdf="pdf"
            :custom-water-mark="getBrandLogo"
            :chart-data="getChartData"
            :chart-options="getChartOptions"
            @watermark-ready="capturePdfChart"
            ref="chart"
        />
        <img v-if="isPdfLoaded" :src="base64Chart" />
    </div>
</template>
